<script>
    // import app from './stores/app';
    import geos from '../stores/geos';
    import {initApp} from "../lib/requests";
    import GeosTree from "./GeosTree.svelte";
    import KritikesGeosTree from "../kritikes/KritikesGeosTree.svelte";


    let loading = false;

    const initializeApplication = async () => {
        if ($geos.tree.length > 0) {
            return;
        }

        loading = true;

        const [err, res] = await initApp();

        if (err) {
            alert('error ' + err)
            return;
        }
        $geos.list = res.list;
        $geos.tree = res.tree;
        $geos.selected_id = res.last_selected_id;

        loading = false;
    }

    initializeApplication();
</script>

{#if (loading)}
    <div class="initializer">
        <div class="logo">
            <img src="/assets/images/logo.png" alt="logo"/>
        </div>
    </div>
{:else}
    <div class="row">
        <div class="col-md-6">
            <GeosTree/>
        </div>
        <div class="col-md-6">
            <KritikesGeosTree/>
        </div>
    </div>
{/if}